import { FormattedTitle } from "@components/atoms/FormattedTitle"
import { MiamiDadeLogo } from "@components/atoms/Logo"
import { themedCSSVar, THEMES } from "@components/atoms/Themed"
import { Button } from "@components/ui/Button"
import { Input } from "@components/ui/Input"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"
import { twMerge } from "tailwind-merge"
import { usePageContext } from "../../contexts/PageContext"
import { cn } from "@utils/tw"

export const meta: BlockMeta = {
  title: "Footer",
  inserter: false,
  tags: [],
}

export default defineBlock("footer/footer", (props) => {
  const { theme: pageTheme } = usePageContext()
  const themeColor = pageTheme && pageTheme !== "none" ? pageTheme : "yellow"
  const themeColorLight = `${themeColor}Light`
  const theme = THEMES[themeColor]
  const themeLight = THEMES[themeColorLight]

  return (
    <>
      <div className={twMerge("mt-11 w-full flex justify-center items-center", theme.bg)}>
        <div className="w-full md:w-footerW flex flex-col">
          <div className="w-full flex justify-center items-center py-7 overflow-hidden">
            <FormattedTitle text={props.introductoryText!} />
          </div>
          <div className="w-full flex flex-col md:flex-row">
            <div className={cn("w-full px-5 md:px-0", theme.bg)}>
              <div className="bg-white mb-6 md:mb-0 md:my-6 md:ml-4 py-5 pl-5 pr-5 md:pr-0 md:h-footerContentH flex flex-col justify-between">
                <div className="w-full flex mt-1 md:mt-0 justify-between flex-wrap md:flex-nowrap">
                  {props.mainItems?.map((item, index) => (
                    <div key={index} className="flex flex-col w-1/2 md:w-1/4 gap-3 mb-8 md:mb-0">
                      <p className="type-label-s">{item?.title}</p>
                      <ul className="flex flex-col gap-3">
                        {item?.links?.map((link, index) => (
                          <li key={index}>
                            <Link
                              href={link?.link?.url}
                              target={link?.link?.target || ""}
                              className="type-body-m hover-link"
                            >
                              {link?.link?.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
                <div className="w-full flex flex-col gap-4">
                  <div className="flex flex-col gap-3">
                    <p className="type-label-s">
                      <EditableText
                        as="span"
                        store="footer-join"
                        defaultValue="Join the festival insider"
                        placeholder="Join the festival insider"
                        plainText
                      />
                    </p>
                    <p className="type-body-m">
                      <EditableText
                        as="span"
                        store="footer-up-to-date"
                        defaultValue="Stay up to date with upcoming releases, exclusive events and festival news"
                        placeholder="Stay up to date with upcoming releases, exclusive events and festival news"
                        plainText
                      />
                    </p>
                  </div>
                  <form
                    action={
                      props.newsletterSubscriptionActionUrl ||
                      "https://MiamiFilmFestival.us15.list-manage.com/subscribe/post?u=7e686bf060d3254f46be20722&amp;id=9f072a1dce&amp;f_id=00a892e0f0"
                    }
                    method="post"
                    id="mc-embedded-subscribe-form"
                    name="mc-embedded-subscribe-form"
                    target="_blank"
                    className="hidden md:flex w-full gap-4 flex-wrap md:flex-nowrap"
                  >
                    <Input
                      type="email"
                      name="EMAIL"
                      size="lg"
                      className="w-full"
                      id="mce-EMAIL"
                      required
                      placeholder="youremail@website.com"
                    />
                    <Button
                      size="lg"
                      className={twMerge("shrink-0 type-title-xs uppercase text-black")}
                      style={{ "--color-primary": themedCSSVar(themeColorLight) } as React.CSSProperties}
                      name="subscribe"
                      type="submit"
                    >
                      <EditableText
                        as="span"
                        store="footer-subscribe"
                        defaultValue="Subscribe"
                        placeholder="Subscribe"
                        plainText
                      />
                    </Button>
                  </form>
                  <form
                    action={
                      props.newsletterSubscriptionActionUrl ||
                      "https://MiamiFilmFestival.us15.list-manage.com/subscribe/post?u=7e686bf060d3254f46be20722&amp;id=9f072a1dce&amp;f_id=00a892e0f0"
                    }
                    method="post"
                    id="mc-embedded-subscribe-form"
                    name="mc-embedded-subscribe-form"
                    target="_blank"
                    className="md:hidden flex gap-4 flex-nowrap -ml-5 w-[calc(100%+(var(--spacing-5)*2))]"
                  >
                    <Input
                      type="email"
                      name="EMAIL"
                      className="w-full pl-5"
                      placeholder="youremail@website.com"
                      id="mce-EMAIL"
                      required
                    />
                    <Button
                      className={twMerge("shrink-0 type-title-xs uppercase text-black")}
                      style={{ "--color-primary": themedCSSVar(themeColorLight) } as React.CSSProperties}
                      name="subscribe"
                      type="submit"
                    >
                      <EditableText
                        as="span"
                        store="footer-subscribe"
                        defaultValue="Subscribe"
                        placeholder="Subscribe"
                        plainText
                      />
                    </Button>
                  </form>
                </div>
              </div>
              <div className="md:w-full flex flex-row md:flex-col justify-between gap-5 mt-5 -ml-5 w-[calc(100%+(var(--spacing-5)*2))]">
                <div className="w-full md:ml-4 pl-6 flex flex-col md:flex-row md:items-center gap-5 type-label-xs">
                  <MiamiDadeLogo />

                  <div className="md:hidden w-full flex flex-col gap-4 mt-4">
                    <p className="mb-4">© {new Date().getFullYear()} Miami Film Festival</p>
                    {[
                      ...(props.legalItems || []),
                      { link: { title: "Site by ED.", url: "https://ed.studio", target: "_blank" } },
                    ]?.map((item, index) => (
                      <Link key={index} href={item?.link?.url} target={item?.link?.target || ""} className="hover-link">
                        {item?.link?.title?.replaceAll("&amp;", "&")}
                      </Link>
                    ))}
                  </div>
                </div>
                <div className="md:hidden w-footerLogoW h-footerLogoH shrink-0">
                  <svg viewBox="0 0 416 488" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="416" height="488" fill="black" />
                    <path
                      d="M30 458.1H63.7V411.44H97.57V383.9H63.7V360.68H109.59V360.64V332.93H30V458.1Z"
                      fill="white"
                    />
                    <path
                      d="M30 306.14H63.7V259.48H97.57V231.94H63.7V208.71H109.59V208.67V180.96H30V306.14Z"
                      fill="white"
                    />
                    <path
                      d="M323.51 104.67L307.54 29H258.25V154.18H288V83.71L287.5 63L307.17 154.18H334.6L354.27 62.91L353.77 83.37V154.18H386.21H386.25V29H339.48L323.51 104.67Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="hidden md:block w-footerLogoW h-footerLogoH shrink-0">
              <svg viewBox="0 0 416 488" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="416" height="488" fill="black" />
                <path d="M30 458.1H63.7V411.44H97.57V383.9H63.7V360.68H109.59V360.64V332.93H30V458.1Z" fill="white" />
                <path
                  d="M30 306.14H63.7V259.48H97.57V231.94H63.7V208.71H109.59V208.67V180.96H30V306.14Z"
                  fill="white"
                />
                <path
                  d="M323.51 104.67L307.54 29H258.25V154.18H288V83.71L287.5 63L307.17 154.18H334.6L354.27 62.91L353.77 83.37V154.18H386.21H386.25V29H339.48L323.51 104.67Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden md:flex w-full justify-between items-center p-4 bg-grey2 type-label-s-light">
        <p>© {new Date().getFullYear()} Miami Film Festival</p>
        {[
          ...(props.legalItems || []),
          { link: { title: "Site by ED.", url: "https://ed.studio", target: "_blank" } },
        ]?.map((item, index) => (
          <Link key={index} href={item?.link?.url} target={item?.link?.target || ""} className="hover-link">
            {item?.link?.title?.replaceAll("&amp;", "&")}
          </Link>
        ))}
      </div>
    </>
  )
})
